'use strict';
var app = require('angular').module('directive.chips', []);

app.directive('chips', [require('./chipsDirective')]);
